export default __webpack_public_path__ + "static/media/45.aabc25dc.png";